import { render, staticRenderFns } from "./WbciCancellation.vue?vue&type=template&id=6be17e2c&scoped=true&"
import script from "./WbciCancellation.vue?vue&type=script&lang=js&"
export * from "./WbciCancellation.vue?vue&type=script&lang=js&"
import style0 from "./WbciCancellation.vue?vue&type=style&index=0&id=6be17e2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be17e2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VRow,VSelect,VTextarea})
